<template>
    <RoomsList />
</template>

<script>
import RoomsList from "@/components/rooms-list/RoomsList.vue";
import { mapGetters } from "vuex";

export default {
    name: "rooms-list",
    components: {
        RoomsList,
    },
    computed: {
        ...mapGetters("oidcStore", ["oidcUser"]),
        isSupervisor() {
            let roles = this.oidcUser.role;
            return roles.indexOf("Supervisor") > -1;
        },
        isAuditor() {
            let roles = this.oidcUser.role;
            return roles.indexOf("Auditor") > -1;
        },
    },
    mounted() {
        if (!this.isSupervisor && !this.isAuditor) {
            this.$router.push({ name: "home" });
        }
    }
};
</script>